import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/site";

const footerLinks = [
  {
    title: "导航",
    links: [
      { label: "首页", path: "/" },
      { label: "全部作品", path: "/category/all" },
      { label: "关于风间由美", path: "/about" },
    ],
  },
  {
    title: "作品分类",
    links: [
      { label: "电影作品", path: "/category/movie" },
      { label: "电视剧集", path: "/category/tv" },
      { label: "舞台剧", path: "/category/stage" },
      { label: "综艺节目", path: "/category/variety" },
    ],
  },
  {
    title: "社交媒体",
    links: [
      { label: "Twitter", path: "https://twitter.com/kazama_yumi" },
      { label: "Instagram", path: "https://instagram.com/kazama_yumi" },
      { label: "YouTube", path: "https://youtube.com/@kazama_yumi" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="text-lg font-semibold text-foreground-950 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              风间由美
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              日本知名女演员与艺人官方粉丝落地页。汇聚最新动态、作品履历、演艺生涯精华及粉丝专属内容。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-medium text-foreground-950 mb-3 whitespace-nowrap">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith("http") ? (
                      <a
                        href={link.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            本站为非官方粉丝站点，所有内容仅供粉丝交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}